import React from 'react';
import { SummaryTab } from './SummaryTab';
import { FindingsTab } from './FindingsTab';
import { ActivityTab } from './ActivityTab';
import { Version, NarrativeLens, RightTabId, SummaryLensId, ResolveState } from './types';
interface RightPanelProps {
  version: Version;
  narrative: NarrativeLens;
  rightTab: RightTabId;
  onTabChange: (tab: RightTabId) => void;
  summaryLens: SummaryLensId;
  onLensChange: (lens: SummaryLensId) => void;
  hasBlockers: boolean;
  isReviewer: boolean;
  isSubmitter: boolean;
  resolveStates: Record<string, ResolveState>;
  onResolve: (id: string, state: ResolveState) => void;
  expandedFinding: string | null;
  onExpandFinding: (id: string | null) => void;
  currentUser: string;
  scanning: boolean;
  allHandled: boolean;
}
export function RightPanel({
  version,
  narrative,
  rightTab,
  onTabChange,
  summaryLens,
  onLensChange,
  hasBlockers,
  isReviewer,
  isSubmitter,
  resolveStates,
  onResolve,
  expandedFinding,
  onExpandFinding,
  currentUser,
  scanning,
  allHandled
}: RightPanelProps) {
  return <div style={{
    background: 'white',
    borderLeft: '1px solid #E6E4DF',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  }} data-id="element-160">
      {/* Header */}
      <div style={{
      padding: '14px 16px 8px',
      borderBottom: '1px solid #E6E4DF'
    }} data-id="element-161">
        {/* Status Banner */}
        {hasBlockers ? <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 10,
        padding: '10px 14px',
        background: '#FEF2F2',
        border: '1px solid #FECACA',
        borderRadius: 8
      }} data-id="element-162">
            <div style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: '#B44D4D',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }} data-id="element-163">
              <span style={{
            color: 'white',
            fontSize: 18,
            fontWeight: 800
          }} data-id="element-164">
                {version.blockers.length}
              </span>
            </div>
            <div data-id="element-165">
              <div style={{
            fontSize: 13,
            fontWeight: 700,
            color: '#B44D4D'
          }} data-id="element-166">
                Blockers must be fixed
              </div>
              <div style={{
            fontSize: 11,
            color: '#DC7A7A'
          }} data-id="element-167">
                Can't submit until resolved
              </div>
            </div>
          </div> : <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 10,
        padding: '10px 14px',
        background: '#ECFDF5',
        border: '1px solid #A7F3D0',
        borderRadius: 8
      }} data-id="element-168">
            <div style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: '#16785E',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }} data-id="element-169">
              <span style={{
            color: 'white',
            fontSize: 16
          }} data-id="element-170">
                ✓
              </span>
            </div>
            <div data-id="element-171">
              <div style={{
            fontSize: 13,
            fontWeight: 700,
            color: '#16785E'
          }} data-id="element-172">
                No blockers
              </div>
              <div style={{
            fontSize: 11,
            color: '#2D7A6E'
          }} data-id="element-173">
                {version.suggestions.length} suggestion
                {version.suggestions.length !== 1 ? 's' : ''} · {version.passed}{' '}
                passed
              </div>
            </div>
          </div>}

        {/* Tabs */}
        <div style={{
        display: 'flex',
        borderBottom: '2px solid #E6E4DF'
      }} data-id="element-174">
          {(['Summary', 'Findings', 'Activity'] as const).map(t => {
          const tabId = t.toLowerCase() as RightTabId;
          return <button key={t} onClick={() => onTabChange(tabId)} style={{
            flex: 1,
            padding: 7,
            background: 'transparent',
            border: 'none',
            borderBottom: rightTab === tabId ? '2px solid #1C2530' : '2px solid transparent',
            marginBottom: -2,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 11.5,
            fontWeight: rightTab === tabId ? 700 : 500,
            color: rightTab === tabId ? '#1C2530' : '#8896A6'
          }} data-id="element-175">
                {t}
              </button>;
        })}
        </div>
      </div>

      {/* Content */}
      <div style={{
      flex: 1,
      overflowY: 'auto'
    }} data-id="element-176">
        {rightTab === 'summary' && !scanning && <SummaryTab narrative={narrative} summaryLens={summaryLens} onLensChange={onLensChange} hasBlockers={hasBlockers} isReviewer={isReviewer} onGoToFindings={() => onTabChange('findings')} data-id="element-177" />}
        {rightTab === 'findings' && !scanning && <FindingsTab version={version} isReviewer={isReviewer} resolveStates={resolveStates} onResolve={onResolve} expandedFinding={expandedFinding} onExpandFinding={onExpandFinding} currentUser={currentUser} data-id="element-178" />}
        {rightTab === 'activity' && <ActivityTab currentUser={currentUser} data-id="element-179" />}
        {scanning && <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 200,
        color: '#8896A6',
        fontSize: 12
      }} data-id="element-180">
            Analyzing…
          </div>}
      </div>

      {/* Bottom Actions */}
      <div style={{
      padding: '10px 16px',
      borderTop: '1px solid #E6E4DF'
    }} data-id="element-181">
        {isSubmitter && hasBlockers && <button disabled style={{
        width: '100%',
        padding: 10,
        borderRadius: 7,
        border: 'none',
        background: '#FEF2F2',
        color: '#B44D4D',
        fontWeight: 700,
        fontSize: 12,
        cursor: 'not-allowed',
        fontFamily: 'inherit'
      }} data-id="element-182">
            Fix {version.blockers.length} blocker
            {version.blockers.length > 1 ? 's' : ''} to submit
          </button>}
        {isSubmitter && !hasBlockers && <button style={{
        width: '100%',
        padding: 10,
        borderRadius: 7,
        border: 'none',
        background: '#16785E',
        color: 'white',
        fontWeight: 700,
        fontSize: 12,
        cursor: 'pointer',
        fontFamily: 'inherit'
      }} data-id="element-183">
            Submit to Compliance →
          </button>}
        {isReviewer && <div style={{
        display: 'flex',
        gap: 6
      }} data-id="element-184">
            <button style={{
          padding: '9px 14px',
          borderRadius: 7,
          border: '1.5px solid #FECACA',
          background: '#FFF5F5',
          color: '#B44D4D',
          fontWeight: 700,
          fontSize: 11.5,
          cursor: 'pointer',
          fontFamily: 'inherit'
        }} data-id="element-185">
              Reject
            </button>
            <button style={{
          padding: '9px 14px',
          borderRadius: 7,
          border: '1.5px solid #FDE68A',
          background: '#FFFBEB',
          color: '#92400E',
          fontWeight: 700,
          fontSize: 11.5,
          cursor: 'pointer',
          fontFamily: 'inherit'
        }} data-id="element-186">
              Changes
            </button>
            <div style={{
          flex: 1
        }} data-id="element-187" />
            <button style={{
          padding: '9px 18px',
          borderRadius: 7,
          border: 'none',
          background: allHandled ? '#16785E' : '#94A3B8',
          color: 'white',
          fontWeight: 700,
          fontSize: 11.5,
          cursor: allHandled ? 'pointer' : 'not-allowed',
          fontFamily: 'inherit'
        }} data-id="element-188">
              {allHandled ? 'Approve ✓' : 'Resolve all to approve'}
            </button>
          </div>}
      </div>
    </div>;
}